import FooterNavbar from "../../../footernavbar/FooterNavbar";

const Jobs = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <div>
          <header>
            <div
              className="page-header min-vh-50"
              style={{
                backgroundImage:
                  "url('https://www.comsavings.com/assets/img/images/Careers1.jpg')",
              }}
            >
              <span className="mask bg-gradient-dark opacity-7"></span>
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 mx-auto text-white text-center">
                    <h1 className="text-white text-10xl">All Jobs</h1>
                    <div className=" d-flex justify-content-center align-items-center mb-4">
                      <div className=" bg-white d-flex justify-content-between px-2 align-items-center w-40 border-radius-40">
                        <div className="input-group input-group-lg">
                          <input
                            type="text"
                            className=" form-control fw-normal fs-5 "
                            placeholder=" Start your search"
                          />
                        </div>
                        <div>
                          <span className="input-group-text p-2 cursor-pointer w-auto rounded-circle btn btn-md btn-primary">
                            <i className="bi bi-search text-white p-1 text-sm"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className=" container w-70 mx-auto">
                      <div className=" d-flex justify-content-center align-items-center gap-4">
                        <div className=" w-25 text-start">
                          <div
                            className=" bg-transparent border p-1 lh-0 cursor-pointer dropdown border-radius-40"
                            id="dropdownTeams"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className=" d-flex justify-content-between align-items-center">
                              <div className=" w-100 p-3 mt-1">
                                <b className=" text-white text-xl text-nowrap">
                                  Team
                                </b>
                              </div>
                              <div className=" w-100 text-end me-3 mt-2">
                                <i className="bi bi-caret-down-fill text-white"></i>
                              </div>
                            </div>
                            <div className="mb-2"></div>
                            <div
                              className="dropdown-menu dropdown-menu-animation  dropdown-lg nav-menu p-2 px-3 border-radius-2xl"
                              aria-labelledby="dropdownTeams"
                            >
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                      Engineering (100)
                                    </b>
                                  </div>
                                </a>
                              </div>
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                      Community Support (100)
                                    </b>
                                  </div>
                                </a>
                              </div>
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                      Operations (100)
                                    </b>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className=" w-25 text-start">
                          <div
                            className=" bg-transparent border p-1 lh-0 cursor-pointer dropdown border-radius-40"
                            id="dropdownWork"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className=" d-flex justify-content-between align-items-center">
                              <div className=" w-100 p-3 mt-1">
                                <b className=" text-white text-xl text-nowrap">
                                  Where you work
                                </b>
                              </div>
                              <div className=" w-100 text-end me-3 mt-2">
                                <i className="bi bi-caret-down-fill text-white"></i>
                              </div>
                            </div>
                            <div className="mb-2"></div>
                            <div
                              className="dropdown-menu dropdown-menu-animation  dropdown-lg nav-menu p-2 px-3 border-radius-2xl"
                              aria-labelledby="dropdownWork"
                            >
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                      India
                                    </b>
                                  </div>
                                </a>
                              </div>
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                    United States
                                    </b>
                                  </div>
                                </a>
                              </div>
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                     Bangalore
                                    </b>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className=" w-25 text-start">
                          <div
                            className=" bg-transparent border p-1 lh-0 cursor-pointer dropdown border-radius-40"
                            id="dropdownFlexibility"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className=" d-flex justify-content-between align-items-center">
                              <div className=" w-100 p-3 mt-1">
                                <b className=" text-white text-xl text-nowrap">
                                  Work Flexibility
                                </b>
                              </div>
                              <div className=" w-100 text-end me-3 mt-2">
                                <i className="bi bi-caret-down-fill text-white"></i>
                              </div>
                            </div>
                            <div className="mb-2"></div>
                            <div
                              className="dropdown-menu dropdown-menu-animation  dropdown-lg nav-menu p-2 px-3 border-radius-2xl"
                              aria-labelledby="dropdownFlexibility"
                            >
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                     Live and work
                                    </b>
                                  </div>
                                </a>
                              </div>
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                      Hybrid
                                    </b>
                                  </div>
                                </a>
                              </div>
                              <div className=" lh-base mt-2 dropdown-item border-radius-md mb-2">
                                <a className="" href=".">
                                  <div>
                                    <b className="fs-6 text-sm fw-normal text-black">
                                      Onsite
                                    </b>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className=" bg-gray-100 min-vh-35">
            <div className="py-5 d-flex justify-content-center align-items-center gap-1">
              <div className=" card bg-white w-25 text-center p-4">
                <b className=" text-black fw-normal fs-3">
                  Opportunities for Students
                </b>
                <div className=" mt-3 mb-3">
                  <p className=" text-black">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Adipisci iure ducimus non omnis tempora? Et maiores harum
                    sunt eligendi? Praesentium cum accusantium omnis distinctio
                    ab ad optio minus alias corrupti?
                  </p>
                </div>
                <div className=" mt-3 mb-3">
                  <button className=" btn btn-outline-dark btn-md w-90">
                    View Open Jobs
                  </button>
                </div>
              </div>
              <div className=" card bg-white w-25 text-center p-4">
                <b className=" text-black fw-normal fs-3">
                  Warehouse and hourly jobs
                </b>
                <div className=" mt-3 mb-3">
                  <p className=" text-black">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Adipisci iure ducimus non omnis tempora? Et maiores harum
                    sunt eligendi? Praesentium cum accusantium omnis distinctio
                    ab ad optio minus alias corrupti?
                  </p>
                </div>
                <div className=" mt-3 mb-3">
                  <button className=" btn btn-outline-dark btn-md w-90">
                    View Open Jobs
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" container w-70 mx-auto pt-5">
            <div className=" text-center mb-5">
              <b className=" text-black fw-normal fs-2">
                Explore Opportunities
              </b>
            </div>
            <div className=" d-flex justify-content-center align-items-center gap-4">
              <div className=" w-100">
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-3.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Android Engineer, DLS Foundation
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-1.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Anti-Discrimination Specialist
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-2.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Associate Principal, Control Testing
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-4.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Communications Intern, EMEA
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-5.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Communications Program Lead
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className=" w-100">
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-3.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Android Engineer, DLS Foundation
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-1.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Anti-Discrimination Specialist
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-2.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Associate Principal, Control Testing
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-4.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Communications Intern, EMEA
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
                <a href="/JobsInside">
                  <div className=" d-flex justify-content-start align-items-center gap-3 mb-3 px-3 background-jobs">
                    <div>
                      <div className="blur-shadow-avatar rounded-circle">
                        <img
                          className="avatar avatar-xl rounded shadow-lg"
                          src="../assets/img/avatar/team-5.jpg"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className=" mt-2">
                      <b className=" text-black fs-5">
                        Communications Program Lead
                      </b>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Illum error..
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Jobs;
